import type { FleetFilesTreeNode } from "../chat/fleet-session-files-tree.ts";
import type { FleetProjectSummary } from "../types.ts";
import {
  renderFleetSessionFilesPanel,
  type FleetSessionFilesPanelProps,
} from "./fleet-session-files-panel.ts";

export type FleetProjectFilesTabProps = FleetSessionFilesPanelProps & {
  sessionKey: string;
  sessionProjects: FleetProjectSummary[];
};

export function renderFleetProjectFilesTab(props: FleetProjectFilesTabProps) {
  return renderFleetSessionFilesPanel({
    loading: props.loading,
    error: props.error,
    workspacePath: props.workspacePath,
    scope: props.scope,
    truncated: props.truncated,
    tree: props.tree as FleetFilesTreeNode[],
    expandedDirs: props.expandedDirs,
    selectedPath: props.selectedPath,
    fileLoading: props.fileLoading,
    fileError: props.fileError,
    fileContent: props.fileContent,
    fileTruncated: props.fileTruncated,
    connected: props.connected,
    onRefresh: props.onRefresh,
    onToggleDir: props.onToggleDir,
    onOpenFile: props.onOpenFile,
    onInsertIntoComposer: props.onInsertIntoComposer,
  });
}
